import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAttach = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.5 6.84495L8.15775 13.1878C7.42635 13.9192 6.43437 14.3301 5.40002 14.3301C4.36567 14.3301 3.37368 13.9192 2.64229 13.1878C1.91089 12.4564 1.5 11.4644 1.5 10.4301C1.5 9.39571 1.91089 8.40372 2.64229 7.67233L7.85152 2.46367C8.09136 2.21534 8.37826 2.01727 8.69547 1.88101C9.01268 1.74474 9.35385 1.67302 9.69908 1.67002C10.0443 1.66702 10.3867 1.7328 10.7062 1.86353C11.0257 1.99426 11.316 2.18732 11.5601 2.43144C11.8043 2.67556 11.9973 2.96586 12.1281 3.28539C12.2588 3.60492 12.3246 3.94728 12.3216 4.29251C12.3186 4.63774 12.2468 4.97891 12.1106 5.29612C11.9743 5.61333 11.7762 5.90022 11.5279 6.14006L6.31926 11.3516C6.07411 11.5885 5.74575 11.7195 5.4049 11.7166C5.06404 11.7137 4.73796 11.5771 4.4969 11.3361C4.25583 11.0951 4.11906 10.769 4.11604 10.4282C4.11303 10.0873 4.24401 9.75892 4.48077 9.5137L9.69001 4.30273",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAttach;
